import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const getStoreSyncConfigApi = createAsyncThunk(
  'storeSynchronization/getStoreSyncConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('store-synchronization/config');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getStoreSyncConfigApi', error, rejectWithValue);
    }
  },
);

export const updateStoreSyncConfigApi = createAsyncThunk(
  'storeSynchronization/updateStoreSyncConfig',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put('store-synchronization/config', data);
      return response.data;
    } catch (error) {
      return handleApiError('updateStoreSyncConfigApi', error, rejectWithValue);
    }
  },
);

export const synchronizeStoresApi = createAsyncThunk(
  'storeSynchronization/synchronizeStores',
  async (storeIds, { rejectWithValue }) => {
    try {
      const response = await api.post('store-synchronization/sync', { storeIds });
      return response.data;
    } catch (error) {
      return handleApiError('synchronizeStoresApi', error, rejectWithValue);
    }
  },
);

export const getStoreSyncProcessStatusApi = createAsyncThunk(
  'storeSynchronization/getProcessStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('store-synchronization/process-status');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getStoreSyncProcessStatusApi', error, rejectWithValue);
    }
  },
);

export const downloadStoreSyncRunReportCsvApi = createAsyncThunk(
  'storeSynchronization/downloadRunReportCsv',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('store-synchronization/run-report/download', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const stamp = new Date().toISOString().slice(0, 10);
      link.setAttribute('download', `store-sync-run-${stamp}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { downloaded: true };
    } catch (error) {
      return handleApiError('downloadStoreSyncRunReportCsvApi', error, rejectWithValue);
    }
  },
);